/* eslint-disable react/destructuring-assignment */
// takes an error message to be displayed at the top of page
// optionally takes an array of missing field ids to highlight with a red border
// error is removed on click

import PropTypes from "prop-types";
import React from "react";

const ErrorDisplay = (props) => {
  const {errorMessage, missingFields} = props.errorParams;

  // this is the class name for an error border
  const errorBorder = "border-red-500";

  const containerElement = document.getElementById("buy-it-now");

  const handleGeneralError = () => {
    const clickOut = containerElement.addEventListener("click", () => {
      containerElement.removeEventListener("click", clickOut);
      props.removeError();
    });
  };

  const handleMissingFields = () => {
    const firstField = document.getElementById(missingFields[0]);

    if (firstField) {
      firstField.scrollIntoView({
        "behavior": "smooth",
        "block": "center",
        "inline": "nearest"
      });
    }

    missingFields.forEach((field) => {
      const input = document.getElementById(field); /* eslint-disable-line prefer-destructuring */

      if (input) {
        input.classList.add(errorBorder);

        const inputClick = containerElement.addEventListener("click", () => {
          input.classList.remove(errorBorder);
          containerElement.removeEventListener("click", inputClick);
          props.removeError();
        });
      }
    });
  };

  /* eslint-disable react/no-multi-comp */
  const renderLoginPrompt = () => (
    <span>
      This email address is associated with an existing Rocksbox account! Please log in
      {" "}
      <a
        className="bold underline"
        href="/signin"
      >
        here.
      </a>
    </span>
  );

  const handleErrors = () => {
    if (missingFields) {
      handleMissingFields();
    } else {
      handleGeneralError();
    }
  };

  handleErrors();

  return (
    <div className="error color-coral-2-bg">
      {errorMessage === "Existing email"
        ? renderLoginPrompt()
        : errorMessage
      }
    </div>
  );
};

ErrorDisplay.propTypes = {
  "errorParams": PropTypes.object,
  "removeError": PropTypes.func.isRequired
};

ErrorDisplay.defaultProps = {"errorParams": null};

export default ErrorDisplay;
